import * as React from 'react';

import { IInstallmentCalculatorData } from './installment-calculator.data';
import { IInstallmentCalculatorProps } from './installment-calculator.props.autogenerated';
import { RichTextComponent, getCatalogId } from '@msdyn365-commerce/core';

import { searchByCriteriaAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { convertProductAttributes } from '../../utilities/data-attribute-parser';
import { attrNames } from '../../utilities/global-constants';
import { observer } from 'mobx-react';
import { observable } from 'mobx';


import { format, Heading } from '@msdyn365-commerce-modules/utilities';

/**
 *
 * InstallmentCalculator component
 * @extends {React.PureComponent<IInstallmentCalculatorProps<IInstallmentCalculatorData>>}
 */

@observer
class InstallmentCalculator extends React.PureComponent<IInstallmentCalculatorProps<IInstallmentCalculatorData>> {

    @observable private hasValidItem = false;

    public async componentDidMount(): Promise<void> {

        const itemIds = [];
        if (this.props.config.contextType === 'cart') {
            const cart = this.props.data.cart.result?.cart;
            cart?.CartLines?.forEach(line => {
                itemIds.push({ ItemId: line.ItemId });
            });
        } else {
            itemIds.push({ ItemId: this.props.data.product.result?.ItemId });
        }

        const searchCriteria = {
            ItemIds: itemIds,
            IncludeProductsFromDescendantCategories: false,
            SkipVariantExpansion: true,
            IncludeAttributes: true,
            Context: {
                ChannelId: this.props.context.request.apiSettings.channelId,
                CatalogId: getCatalogId(this.props.context.request)
            }
        };

        const products = await searchByCriteriaAsync({ callerContext: this.props.context.actionContext }, searchCriteria);

        products.forEach(product => {
            const formattedAtr = convertProductAttributes(product.AttributeValues || []);

            if (formattedAtr[attrNames.isInstallmentEligible]) {
                this.hasValidItem = true;
            }
        });
    }

    public render(): JSX.Element | null {

        const { config, context, resources, data } = this.props;

        let price = config.contextType === 'cart' ? data.cart.result?.cart.TotalAmount : data.product.result?.AdjustedPrice;

        if (!price || !this.hasValidItem || price < this.props.app.config.installments.minimum) {
            return null;
        }

        const feeAmount: number = this.props.context.app.config.installments.feeAmount;
        price = price + feeAmount;

        const installments = parseFloat(((price * this.props.app.config.installments.percentInstallments) / this.props.app.config.installments.numberOfPayments).toFixed(2));
        const downpayment = parseFloat((price - (installments * this.props.app.config.installments.numberOfPayments)).toFixed(2));

        const formatCurrency = context.cultureFormatter.formatCurrency;
        return (
            <div className='installment-cal'>
                <div className='installment-cal__summary'>
                    {(config.header || config.subheader) && (
                        <div className='installment-cal__header'>
                            {config.header &&
                                <Heading
                                    className='installment-cal__heading'
                                    headingTag={config.header.tag}
                                    text={config.header.text}
                                />
                            }
                            {config.subheader && <div className='installment-cal__subheading'>{config.subheader}</div>}
                        </div>
                    )}
                    {config.link?.linkUrl.destinationUrl &&
                        <a className='installment-cal__link' href={config.link.linkUrl.destinationUrl} aria-label={config.link.ariaLabel}>
                            {config.link.linkText}
                        </a>
                    }
                </div>
                <div className='installment-cal__details'>
                    <div className='installment-cal__plan'>
                        {format(
                            resources.installPlan,
                            formatCurrency(downpayment),
                            formatCurrency(installments),
                            formatCurrency(price)
                        )}
                    </div>

                    {config.footnote && <RichTextComponent text={config.footnote} className='installment-cal__footnote' />}
                </div>
            </div>
        );
    }

}

export default InstallmentCalculator;
